import { makeStyles } from '@material-ui/core';
import { iconStaticClassName } from '../Icon/Icon.js';

var weights = {
    regular: 400,
    medium: 500,
    'semi-bold': 600,
    bold: 700,
};
var getCustomColor = function (theme, color) {
    var isCommonColor = color && ['white', 'black'].includes(color);
    var isGreyColor = color && color.match(/^grey\.\d{3}/);
    var isSemanticColor = color && color.match(/(primary|secondary|info|success|error|warning).?(light|dark)?/);
    var isTextColor = color && ['textPrimary', 'textSecondary'].includes(color);
    switch (true) {
        case isCommonColor:
            // @ts-expect-error - todo.
            return theme.palette.common[color];
        case Boolean(isGreyColor):
            var scale = color.split('.')[1];
            // @ts-expect-error - todo.
            return theme.palette.grey[scale] || theme.palette.grey[900];
        case Boolean(isSemanticColor):
            var _a = color.split('.'), paletteKey = _a[0], _b = _a[1], variant = _b === void 0 ? 'main' : _b;
            // @ts-expect-error - todo.
            return theme.palette[paletteKey][variant];
        case isTextColor:
            // @ts-expect-error - todo.
            return theme.palette.text[color.slice(4).toLowerCase()];
        default:
            return undefined;
    }
};
var useTypographyStyles = makeStyles(function (theme) {
    var _a;
    return ({
        root: (_a = {},
            _a["& ." + iconStaticClassName] = {
                position: 'relative',
                top: '0.125em',
                padding: '0 0.125em',
                boxSizing: 'content-box',
            },
            _a.fontFamily = theme.typography.fontFamily,
            _a.fontWeight = function (_a) {
                var variant = _a.variant, weight = _a.weight;
                return (weight ? weights[weight] : theme.typography[variant].fontWeight);
            },
            _a.fontSize = function (_a) {
                var variant = _a.variant;
                return theme.typography[variant].fontSize;
            },
            _a.lineHeight = function (_a) {
                var variant = _a.variant;
                return theme.typography[variant].lineHeight;
            },
            _a.textTransform = function (_a) {
                var variant = _a.variant;
                return theme.typography[variant].textTransform;
            },
            _a.color = function (_a) {
                var color = _a.color, variant = _a.variant;
                return (color && getCustomColor(theme, color)) || theme.typography[variant].color;
            },
            _a),
        caption: {
            display: 'inline',
        },
        overline: {
            display: 'inline',
        },
    });
});

export { useTypographyStyles };
//# sourceMappingURL=TypographyStyles.js.map
